/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EventActionDealCreated } from '../models/EventActionDealCreated';
import type { PaginatedEventActionDealCreatedList } from '../models/PaginatedEventActionDealCreatedList';
import type { PatchedEventActionDealCreated } from '../models/PatchedEventActionDealCreated';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class EventsEventActionDealCreatedService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns PaginatedEventActionDealCreatedList
     * @throws ApiError
     */
    public eventsEventActionDealCreatedList({
        page,
        pageSize,
    }: {
        /**
         * A page number within the paginated result set.
         */
        page?: number,
        /**
         * Number of results to return per page.
         */
        pageSize?: number,
    }): CancelablePromise<PaginatedEventActionDealCreatedList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/events-event-action-deal-created/',
            query: {
                'page': page,
                'page_size': pageSize,
            },
        });
    }

    /**
     * @returns EventActionDealCreated
     * @throws ApiError
     */
    public eventsEventActionDealCreatedCreate({
        requestBody,
    }: {
        requestBody: EventActionDealCreated,
    }): CancelablePromise<EventActionDealCreated> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/events-event-action-deal-created/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns EventActionDealCreated
     * @throws ApiError
     */
    public eventsEventActionDealCreatedRetrieve({
        id,
    }: {
        /**
         * A unique integer value identifying this event action deal created.
         */
        id: number,
    }): CancelablePromise<EventActionDealCreated> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/events-event-action-deal-created/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns EventActionDealCreated
     * @throws ApiError
     */
    public eventsEventActionDealCreatedUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this event action deal created.
         */
        id: number,
        requestBody: EventActionDealCreated,
    }): CancelablePromise<EventActionDealCreated> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/events-event-action-deal-created/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns EventActionDealCreated
     * @throws ApiError
     */
    public eventsEventActionDealCreatedPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this event action deal created.
         */
        id: number,
        requestBody?: PatchedEventActionDealCreated,
    }): CancelablePromise<EventActionDealCreated> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/events-event-action-deal-created/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public eventsEventActionDealCreatedDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this event action deal created.
         */
        id: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/events-event-action-deal-created/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
